import React from 'react';
import PropTypes from 'prop-types';
import { icons } from 'smartsuite-ui/lib/constants/icons';
import { Title } from 'smartsuite-ui/lib/typography/Title';
import { libraryViews } from '../shared/constants/constants';
import DashboardViewTitle from './DashboardViewTitle';
import { useLabelContext } from '../shared/hooks/labelContext';

export default function BreadCrumb(props) {
    const { dashboardLabels } = useLabelContext();

    if (props.currentView === libraryViews.dashboards) {
        return (
            <div className="bread-crumb">
                <Title cssClassModifiers={['size-small']}>
                    {dashboardLabels.dashboards}
                </Title>
            </div>
        );
    }

    return (
        <div className="bread-crumb">
            <Title cssClassModifiers={['size-small']}>
                <button
                    type="button"
                    className="bread-crumb__go-back"
                    onClick={props.goBackToDashboardView}
                >
                    {dashboardLabels.dashboards}
                </button>
            </Title>
            <span className={icons.chevronRight} />
            <Title cssClassModifiers={['size-small']}>
                <DashboardViewTitle
                    dashboardTitle={props.selectedDashboardView.dashboardTitle}
                    viewKey={props.selectedDashboardView.viewKey}
                    viewTitle={props.selectedDashboardView.viewTitle}
                />
            </Title>
        </div>
    );
}

BreadCrumb.propTypes = {
    currentView: PropTypes.string.isRequired,
    goBackToDashboardView: PropTypes.func.isRequired,
    selectedDashboardView: PropTypes.instanceOf(Object),
};
